import React, { PropsWithChildren } from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import { BstContextProvider } from "./stores/BstContextProvider";

const ContextProvider: React.FC<PropsWithChildren<{}>> = ({ children }) => (
  <BstContextProvider>{children}</BstContextProvider>
);

const container = document.getElementById("root");
if (!container) throw new Error("Root container missing in index.html");

const root = ReactDOM.createRoot(container);
root.render(
  <ContextProvider>
    <App />
  </ContextProvider>
);
